<button
  (click)="placeOrder()"
  class="btn btn-primary btn-block"
  [class.disabled]="isDisabled"
  [disabled]="isDisabled"
  [ngClass]="{
    rotating: placeOrderInprogress
  }"
>
  {{ placeOrderInprogress ? '' : ('checkoutReview.placeOrder' | cxTranslate) }}
</button>
